import { createFileRoute } from '@tanstack/react-router';
import { DataStoragePage } from '@/features/admin/pages';

export const Route = createFileRoute('/admin/data-storage')({
  component: DataStoragePage,
});
